import { call, put } from "redux-saga/effects";
import eventService from "../services/eventService";
import { eventConstants } from "../actions/constants/eventConstants";
import { commonConstants } from "@/actions/constants/commonConstants";

function* createEvent(action: any): any {
    try {
        const response = yield call(eventService.createEvent, action.payload);
        if (response.success) {
            yield put({ type: eventConstants.createEventSuccess, payload: response.resultObject });
            yield put({
                type: commonConstants.showSuccessMessage,
                payload: response.message || response.errorMessage,
            });
        } else {
            yield put({ type: eventConstants.createEventFailure, payload: response.errorMessage });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.errorMessage || "Failed to create event",
            });
        }
    } catch (error: any) {
        yield put({ type: eventConstants.createEventFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error?.errorMessage || "Failed to create event" });
    }
}

function* listEvents(action: any): any {
    try {
        const response = yield call(eventService.listEvents, action.payload);
        if (response.success) {
            yield put({ type: eventConstants.listEventsSuccess, payload: response.resultObject });
        } else {
            yield put({ type: eventConstants.listEventsFailure, payload: response.errorMessage });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.errorMessage || "Failed to list events",
            });
        }
    } catch (error: any) {
        yield put({ type: eventConstants.listEventsFailure, payload: error });
        yield put({
            type: commonConstants.showErrorMessage,
            payload: error || "Failed to list events",
        });
    }
}

export const eventsSaga = { createEvent, listEvents, assignMemberToEventsSaga };
function* viewEvent(action: any): any {
    try {
        const response = yield call(eventService.viewEvent, action.payload);
        if (response.success) {
            yield put({ type: eventConstants.viewEventsSuccess, payload: response.resultObject });
        } else {
            yield put({
                type: eventConstants.viewEventsFailure,
                payload: response.message || response.errorMessage,
            });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.message || response.errorMessage,
            });
        }
    } catch (error) {
        yield put({ type: eventConstants.viewEventsFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}
function* updateEvent(action: any): any {
    try {
        const response = yield call(eventService.updateEvent, action.payload);
        if (response.success) {
            if (response.resultObject?.requiresConfirmation) {
                yield put({
                    type: eventConstants.updateEventsRequiresConfirmation,
                    payload: {
                        impactSummary: response.resultObject.impactSummary || [],
                        impactKind: response.resultObject.impactKind || "service-removed",
                        message: response.message || response.resultObject.message || "",
                        pendingPayload: action.payload,
                    },
                });
                return;
            }
            yield put({ type: eventConstants.updateEventsSuccess, payload: response.resultObject });
            yield put({
                type: commonConstants.showSuccessMessage,
                payload: response.message || response.errorMessage,
            })
        } else {
            yield put({
                type: eventConstants.updateEventsFailure,
                payload: response.message || response.errorMessage,
            });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.message || response.errorMessage,
            });
        }
    } catch (error) {
        yield put({ type: eventConstants.updateEventsFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}

function* assignMemberToEventsSaga(action: any): any {
    try {
        const response = yield call(eventService.assignMemberToEventsService, action.payload);
        if (response.success) {
            yield put({
                type: eventConstants.assignMemberToEventsSuccess,
                payload: response.resultObject,
            });
            yield put({
                type: eventConstants.viewEventsRequest,
                payload: { id: action.payload.eventId }
            });
            yield put({
                type: commonConstants.showSuccessMessage,
                payload: response.message || "Team assigned successfully"
            });
        } else {
            yield put({
                type: eventConstants.assignMemberToEventsFailure,
                payload: response.errorMessage,
            });
            yield put({
                type: commonConstants.showErrorMessage,
                payload: response.errorMessage || "Failed to assign team"
            });
        }
    } catch (error: any) {
        yield put({ type: eventConstants.assignMemberToEventsFailure, payload: error });
        yield put({
            type: commonConstants.showErrorMessage,
            payload: error?.message || "Failed to assign team"
        });
    }
}

function* closeEventSaga(action: any): any {
    try {
        const response = yield call(eventService.closeEvent, action.payload);
        if (response.success) {
            yield put({ type: eventConstants.closeEventSuccess, payload: response.resultObject });
            yield put({
                type: eventConstants.viewEventsRequest,
                payload: {
                    id: action.payload.eventId,
                },
            });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message});
        } else {
            yield put({ type: eventConstants.closeEventFailure, payload: response.errorMessage });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage});
        }
    } catch (error: any) {
        yield put({ type: eventConstants.closeEventFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}

function* getEventsWithEnquiriesSaga(action: any): any {
    try {
        const response = yield call(eventService.getEventsWithEnquiries, action.payload);
        if (response.success) {
            yield put({ type: eventConstants.getEventsWithEnquiriesSuccess, payload: response.resultObject });
        } else {
            yield put({ type: eventConstants.getEventsWithEnquiriesFailure, payload: response.errorMessage });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error: any) {
        yield put({ type: eventConstants.getEventsWithEnquiriesFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}

function* updateEventStageSaga(action: any): any {
    try {
        const response = yield call(eventService.updateEventStage, action.payload);
        if (response.success) {
            yield put({ type: eventConstants.updateEventStageSuccess, payload: response.resultObject });
            yield put({ type: commonConstants.showSuccessMessage, payload: response.message });
        } else {
            yield put({ type: eventConstants.updateEventStageFailure, payload: response.errorMessage });
            yield put({ type: commonConstants.showErrorMessage, payload: response.errorMessage });
        }
    } catch (error: any) {
        yield put({ type: eventConstants.updateEventStageFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error });
    }
}

export const eventSaga =  { createEvent, listEvents, viewEvent, updateEvent, assignMemberToEventsSaga, closeEventSaga, getEventsWithEnquiriesSaga, updateEventStageSaga };
